/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pumps_Warning_5Inputs */



/**
* | output |
* | --- |
* | "Without command and without run feedback, the pump status is not displayed" |
*
* @param {Pumps_Warning_5Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const pumps_warning_5 = /** @type {((inputs?: Pumps_Warning_5Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pumps_Warning_5Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Without command and without run feedback, the pump status is not displayed")
	return /** @type {LocalizedString} */ ("En l'absence de commande et de retour de marche, le status des pompes n'est pas affiché")
});